import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


import {Howl, Howler} from 'howler';


class Sound extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0


    this.ref = {
      logo: null, volume: null, trigger: null,
      project: [], spacer3: null, row: []
    }

  }

  mount() {  

    //0-20
    //20-40
    //40-41750
    //41750  - 43417
    //43417 - 45083
    //45083 - 45333
    //45333 - 45455

    //Howler.autoUnlock = false;

   


    var logo = new Howl({
      src: ['/sound/logo2.mp3'],
      loop: true
      
    });
    var about = new Howl({
        src: ['/sound/about_us.mp3'],
        loop: true
    });

    var breath = new Howl({
        src: ['/sound/breath1.mp3']

    });
    var breath2 = new Howl({
        src: ['/sound/breath2.mp3']

    });
    var breath3 = new Howl({
        src: ['/sound/breath3.mp3']

    });

     _each(this.ref.row, (item, index) => {

         const desc = item.dataset.sound

         this[`${desc}_off`] = new Howl({
             src: [`/sound/${desc}_off.mp3`]
         });
         this[`${desc}_on`] = new Howl({
             src: [`/sound/${desc}_on.mp3`]
         });

     })

    
    

  
    
    

    this.breaths = [breath, breath2, breath3]

    _each(this.ref.project, (item, index) => {
        this.transitionInB = this.transitionIn.bind(this)

        item.addEventListener("mouseenter", this.transitionInB, {
            passive: true
        });
        item.addEventListener("touchstart", this.transitionInB, {
            passive: true
        });
       
    })

    


    if (this.ref.logo) {
      this.anim1 =  gsap.fromTo(
            logo, {
                ease: 'none',
                volume: 1
            }, {
                scrollTrigger: {
                    trigger: this.ref.trigger,
                    start: 'top top+=1%',
                    end: "bottom top",
                    id: "sound1",
                    scrub: true,
                    onEnter: self => {

                        console.log('enter logo');
                        logo.play()

                       // this.paused = !self.isActive
                       // this.element.classList.toggle('is-paused', !self.isActive)
                       // this.change()
                    },
                    onLeave: self => {

                        console.log('leave logo');
                        logo.stop()

                        // this.paused = !self.isActive
                        // this.element.classList.toggle('is-paused', !self.isActive)
                        // this.change()
                    },
                    onEnterBack: self => {

                        console.log('enter Back logo');
                        logo.play()


                        // this.paused = !self.isActive
                        // this.element.classList.toggle('is-paused', !self.isActive)
                        // this.change()
                    }
                },
                ease: 'none',
                volume: 0
            }
        )


        this.anim2 = gsap.fromTo(
            logo, {
                ease: 'none',
                volume: 0
            }, {
                scrollTrigger: {
                    trigger: this.element,
                    start: 'bottom bottom',
                    end: "bottom top",
                    id: "sound2",
                    scrub: true,
                    onEnter: self => {

                        console.log('enter footer');
                        logo.play()
                       

                    },
                    onLeaveBack: self => {

                        console.log('leave footer');
                        logo.stop()


                    }
                },
                ease: 'none',
                volume: 1
            }
        )
    }

    this.anim3 = gsap.fromTo(about, {
                ease: 'none',
                volume: 0
            }, {
            ease: 'none',
            volume: 1,
            scrollTrigger: {
                trigger: this.ref.spacer3,
                id: "sound3",
                start: "top bottom-=20%", // the default values
                end: "top top+=1%",
                scrub: true,
                onEnter: self => {

                    console.log('enter topt about');
                    about.play()
                   

                    // this.paused = !self.isActive
                    // this.element.classList.toggle('is-paused', !self.isActive)
                    // this.change()
                },
                onLeaveBack: self => {

                    console.log('leave back top about');
                    about.stop()


                    // this.paused = !self.isActive
                    // this.element.classList.toggle('is-paused', !self.isActive)
                    // this.change()
                }

        },
    });

    this.anim4 = gsap.fromTo(about, {
        ease: 'none',
        volume: 1
    }, {
        ease: 'none',
        volume: 0,
        scrollTrigger: {
            trigger: this.ref.spacer3,
            start: "top top-=1%", // the default values
            end: "bottom top+=50%",
            id: "sound4",
            scrub: true,
            onLeave: self => {

                console.log('leave about');
                about.stop()

                // this.paused = !self.isActive
                // this.element.classList.toggle('is-paused', !self.isActive)
                // this.change()
            },
            onEnterBack: self => {

                console.log('enter back about');
                about.play()

                // this.paused = !self.isActive
                // this.element.classList.toggle('is-paused', !self.isActive)
                // this.change()
            }

        },
    });


    


    _each(this.ref.row, (item,  index) => {

        $(item).on('click', (e) => {

        let sound = item.dataset.sound
      
        if (Howler.volume() > 0) {
          if($(item).hasClass('is-opened')){
                
                this[`${sound}_off`].play()
          }
          else {
                this[`${sound}_on`].play()
          }
        }
        })
    

    })
    
}

shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};


transitionIn(){

    const shuffledArray = this.shuffle(this.breaths);
    if (Howler.volume() > 0 ) {
        shuffledArray[0].play()
    }
}

  unmount() {


    _each(this.ref.project, (item, index) => {

        item.removeEventListener("mouseenter", this.transitionInB);
        item.removeEventListener("touchstart", this.transitionInB);

        

         this.anim1.kill()
         this.anim2.kill()
         this.anim3.kill()
         this.anim4.kill()

         Howler.unload()

    })



  }


}

module.exports = Sound
